/**
 * Cart Upsell Carousel
 * - Variant select/radio/swatch: updates data-upsell-variant-id + displayed price
 * - Add-to-cart: click handler fetches /cart/add.js, dispatches cart:update
 * - Prevents slideshow drag from blocking interactive elements
 * Carousel behaviour is handled by the theme's native slideshow-component.
 */

/*
 * Defensive flag: after an upsell product is added and the cart DOM is morphed,
 * third-party scripts (e.g. Route shipping protection) may lose their internal
 * state, breaking the native checkout form submission. When this flag is true
 * we bypass the form submit and navigate directly to /checkout.
 */
var upsellWasAdded = false;

document.addEventListener(
  'click',
  function (e) {
    if (!upsellWasAdded) return;
    var btn = e.target.closest('.cart__ctas button[type="submit"]');
    if (!btn) return;
    /* Don't block Route — let it handle the click normally so it can add
       shipping protection to the cart. If Route's handler is broken after
       the DOM morph and fails to redirect, this timeout navigates as a
       fallback. If Route succeeds first the page unloads and the timeout
       never fires. */

    /* Visual feedback: show loading state on ALL checkout buttons */
    var allBtns = document.querySelectorAll('.cart__ctas button[type="submit"]');
    allBtns.forEach(function (b) {
      b.disabled = true;
      b.style.position = 'relative';
      b.style.pointerEvents = 'none';
      b.dataset.originalText = b.textContent;
      b.innerHTML =
        '<span style="display:flex;align-items:center;justify-content:center;width:100%;">' +
          '<svg width="16" height="16" viewBox="0 0 16 16" style="animation:mp-spin .6s linear infinite;" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<circle cx="8" cy="8" r="6.5" stroke="currentColor" stroke-width="2" opacity=".25"/>' +
            '<path d="M14.5 8a6.5 6.5 0 0 0-6.5-6.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
          '</svg>' +
        '</span>';
    });
    /* Inject keyframes once */
    if (!document.getElementById('mp-spin-style')) {
      var s = document.createElement('style');
      s.id = 'mp-spin-style';
      s.textContent = '@keyframes mp-spin{to{transform:rotate(360deg)}}';
      document.head.appendChild(s);
    }
    setTimeout(function () {
      window.location.href = '/checkout';
    }, 1500);
  },
  true
);

/* Reset checkout buttons when the page is restored from back-forward cache */
window.addEventListener('pageshow', function (e) {
  if (!e.persisted) return;
  document.querySelectorAll('.cart__ctas button[type="submit"]').forEach(function (b) {
    if (b.dataset.originalText) {
      b.innerHTML = b.dataset.originalText;
      b.disabled = false;
      b.style.pointerEvents = '';
      b.style.position = '';
      delete b.dataset.originalText;
    }
  });
});

/*
 * Stop mousedown from reaching the slideshow's drag handler
 * on interactive elements. The slideshow calls event.preventDefault()
 * on all mousedowns which blocks native <select> from opening.
 */
document.addEventListener(
  'mousedown',
  (e) => {
    if (
      e.target.closest(
        '.mp-cart-upsell__card select, .mp-cart-upsell__card button, .mp-cart-upsell__card a, .mp-cart-upsell__card label, .mp-cart-upsell__swatch-label'
      )
    ) {
      e.stopPropagation();
    }
  },
  true
);

/* ---- Helper: update variant ID + price displays ----
 * `data` is the dataset of the selected option/radio: price, comparePrice, savings.
 * Compare-at and savings are hidden when the selected variant is not on sale. */
function updateUpsellVariant(card, variantId, data) {
  var wrap = card.querySelector('.mp-cart-upsell__form-wrap');
  if (wrap) wrap.dataset.upsellVariantId = variantId;

  var price = data && data.price;

  var priceDisplay = card.querySelector('[data-upsell-price-display]');
  if (priceDisplay && price) priceDisplay.textContent = price;

  var btnPrice = card.querySelector('[data-upsell-btn-price]');
  if (btnPrice && price) btnPrice.textContent = ' \u00B7 ' + price;

  var compareDisplay = card.querySelector('[data-upsell-compare-display]');
  if (compareDisplay) {
    var comparePrice = (data && data.comparePrice) || '';
    compareDisplay.textContent = comparePrice;
    compareDisplay.hidden = !comparePrice;
  }

  var savingsDisplay = card.querySelector('[data-upsell-savings-display]');
  if (savingsDisplay) {
    var savings = (data && data.savings) || '';
    savingsDisplay.textContent = savings;
    savingsDisplay.hidden = !savings;
  }
}

/* ---- Variant select (dropdown) ---- */
document.addEventListener('change', function (e) {
  var select = e.target.closest('[data-upsell-variant-select]');
  if (!select) return;

  var card = select.closest('.mp-cart-upsell__card');
  if (!card) return;

  var opt = select.options[select.selectedIndex];
  updateUpsellVariant(card, select.value, opt && opt.dataset);
});

/* ---- Variant radio buttons ---- */
document.addEventListener('change', function (e) {
  var radio = e.target.closest('[data-upsell-variant-radio]');
  if (!radio) return;

  var card = radio.closest('.mp-cart-upsell__card');
  if (!card) return;

  updateUpsellVariant(card, radio.value, radio.dataset);
});

/* ---- Swatch label click ---- */
document.addEventListener('click', function (e) {
  var label = e.target.closest('.mp-cart-upsell__swatch-label');
  if (!label) return;

  var radio = label.querySelector('[data-upsell-variant-radio]');
  if (!radio) return;

  radio.checked = true;

  var card = label.closest('.mp-cart-upsell__card');
  if (card) updateUpsellVariant(card, radio.value, radio.dataset);
});

/* ---- Add-to-cart button click ---- */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-upsell-add-btn]');
  if (!btn) return;
  if (btn.dataset.added === 'true') return;

  var card = btn.closest('.mp-cart-upsell__card');
  if (!card) return;

  var wrap = card.querySelector('.mp-cart-upsell__form-wrap');
  if (!wrap) return;

  var variantId = wrap.dataset.upsellVariantId;
  if (!variantId) return;

  /* Disable button to prevent double-clicks */
  btn.disabled = true;

  /* Collect cart section IDs so the response includes updated HTML */
  var sectionIds = [];
  document.querySelectorAll('cart-items-component').forEach(function (el) {
    if (el.dataset && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
  });

  /* Check for preorder shipping date line item property */
  var properties = {};
  var preorderScript = wrap.querySelector('[data-preorder-dates]');
  if (preorderScript) {
    try {
      var dates = JSON.parse(preorderScript.textContent);
      if (dates[variantId]) {
        properties['Shipping Date'] = dates[variantId];
      }
    } catch (_) {
      /* ignore parse errors */
    }
  }

  var item = { id: parseInt(variantId, 10), quantity: 1 };
  if (Object.keys(properties).length) item.properties = properties;

  var body = { items: [item] };
  if (sectionIds.length) body.sections = sectionIds.join(',');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  })
    .then(function (res) {
      return res.json();
    })
    .then(function (data) {
      if (data.status) {
        console.error('Cart upsell add error:', data.description || data.message);
        btn.disabled = false;
        return;
      }

      /* Success animation: show checkmark, then dispatch cart:update after animation plays */
      btn.dataset.added = 'true';
      upsellWasAdded = true;

      setTimeout(function () {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: data,
              sourceId: 'mp-cart-upsell',
              data: {
                source: 'mp-cart-upsell',
                itemCount: 1,
                sections: data.sections || {},
              },
            },
          })
        );
      }, 900);
    })
    .catch(function (err) {
      console.error('Cart upsell fetch error:', err);
      btn.disabled = false;
    });
});

/* ---- Sync arrow visibility ---- */
function syncUpsellArrows() {
  var container = document.querySelector('.mp-cart-upsell slideshow-component');
  if (!container) return;

  var prev = container.querySelector('slideshow-arrows .slideshow-control:first-child');
  var next = container.querySelector('slideshow-arrows .slideshow-control:last-child');
  var slides = container.querySelectorAll('slideshow-slide');

  if (!prev || !next || slides.length <= 1) return;

  var scroller = container.querySelector('slideshow-slides');
  if (!scroller) return;

  var scrollLeft = scroller.scrollLeft;
  var isAtStart = scrollLeft <= 5;
  var isAtEnd = scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 5;

  prev.disabled = isAtStart;
  next.disabled = isAtEnd;
}

/* Targeted observer: only watch the upsell slideshow, not the entire body */
var upsellArrowObserver = null;

function attachUpsellObserver() {
  if (upsellArrowObserver) return;

  var container = document.querySelector('.mp-cart-upsell slideshow-component');
  if (!container) return;

  upsellArrowObserver = new MutationObserver(syncUpsellArrows);
  upsellArrowObserver.observe(container, { childList: true, subtree: true });
  syncUpsellArrows();
}

/* Attach on load if container already exists */
attachUpsellObserver();

/* Re-attach after cart updates (cart drawer content gets re-rendered) */
document.addEventListener('cart:update', function () {
  if (upsellArrowObserver) {
    upsellArrowObserver.disconnect();
    upsellArrowObserver = null;
  }
  requestAnimationFrame(attachUpsellObserver);
});

document.addEventListener(
  'scrollend',
  function (e) {
    if (e.target.closest && e.target.closest('.mp-cart-upsell slideshow-slides')) {
      syncUpsellArrows();
    }
  },
  true
);
